var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBold = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "bold_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.708 9.833A3.07 3.07 0 0 0 14.167 7.5a3.275 3.275 0 0 0-3.217-3.333H5.542v11.666h5.833a3.117 3.117 0 0 0 3.083-3.15v-.1a3.03 3.03 0 0 0-1.75-2.75m-5.5-4h3.5a1.74 1.74 0 0 1 1.667 1.084 1.74 1.74 0 0 1-1.142 2.175q-.256.075-.525.074h-3.5zm3.834 8.334H7.208v-3.334h3.834a1.74 1.74 0 0 1 1.666 1.083 1.74 1.74 0 0 1-1.141 2.175 1.9 1.9 0 0 1-.525.075"
})));
export default SvgBold;